import { render, staticRenderFns } from "./DriversPriority.vue?vue&type=template&id=34c889bb&scoped=true"
import script from "./DriversPriority.vue?vue&type=script&lang=js"
export * from "./DriversPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c889bb",
  null
  
)

export default component.exports